import React, { useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useNavigate } from '@/hooks';
import { AppContextProvider } from '@/context';
import { ErrorBoundary, Layout, NotFound } from '@/components';
import { Route, Routes, Navigate, useParams } from 'react-router-dom';
import { httpRequest, LocationDetails } from '@/services';
import {
  Home,
  Terms,
  PlaceOrder,
  OrderDetails,
  ContactUs,
  Blog,
  BlogPost,
  Videos,
} from '@/pages';

import './assets/site.scss';
import { LandingPage } from './pages';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export default function App({ baseUrl, rootElement }) {
  const subdomain = window.location.hostname.split('.')[0];
  const currentUrl = window.location.href;
  const [dynamicUrl, setDynamicUrl] = useState(null);
  const [locationID, setLocationID] = useState(null);
  const [locations, setLocations] = useState();

  return (
    <AppContextProvider value={{ baseUrl, rootElement }}>
      <Layout>
        <ErrorBoundary showDialog>
          <SentryRoutes>

            {subdomain.includes('events') && (
              <>
                <Route path="/" element={<LandingPage />} />
              </>
            )}
            <Route path="*" element={<NotFound />} />
            {(
              <>
                <Route path="/" element={<Home locationID={locationID} />} />
                <Route path="/contact" element={<ContactUsRouter />} />
                <Route path="order" element={<OrderRouter />} />
                <Route path="order/step-1" element={<OrderRouter />} />
                <Route path="order/step/:stepNumber?" element={<OrderRouter />} />
                <Route path="/order/details/:confirmationNumber" element={<OrderDetailsRouter />} />
                <Route path="/videos/:slug" element={<Videos />} />
                <Route path="/blog">
                  <Route index element={<Blog />} />
                  <Route path=":slug" element={<BlogPost />} />
                  <Route path="page-:pageNumber" element={<Blog />} />
                  <Route path="categories/:category">
                    <Route path="" element={<Blog />} />
                    <Route path="page-:pageNumber" element={<Blog />} />
                  </Route>
                </Route>
              </>
            )}            
          </SentryRoutes>
        </ErrorBoundary>
      </Layout>
    </AppContextProvider>
  );
}

function ContactUsRouter() {
  const locationID = sessionStorage.getItem('locationID');
  const [detailedLocationSettings, isLoading] = LocationDetails();
  const [updatedlocationID, setupdatedlocationID] = useState(undefined);
  useEffect(() => {
    if (!isLoading && detailedLocationSettings.length > 0) {
      const locationIdFromSettings = detailedLocationSettings[0].locationID || null;
      setupdatedlocationID(locationIdFromSettings);
    } else if (!isLoading && detailedLocationSettings.length === 0) {
      setupdatedlocationID(null);
    }
  }, [detailedLocationSettings, isLoading]);

  if (!locationID && (isLoading || updatedlocationID === undefined)) {
    return null;
  }

  if (!locationID && updatedlocationID === null) {
    return <NotFound />;
  }

  const LocationIDparam = locationID || updatedlocationID;
  return <ContactUs locationID={LocationIDparam} />;
}

function OrderRouter() {
  const navigate = useNavigate();
  let { stepNumber } = useParams();
  const locationID = sessionStorage.getItem('locationID');
  const [detailedLocationSettings, isLoading] = LocationDetails();
  const [updatedlocationID, setupdatedlocationID] = useState(undefined);
  useEffect(() => {
    if (!isLoading && detailedLocationSettings.length > 0) {
      const locationIdFromSettings = detailedLocationSettings[0].locationID || null;
      setupdatedlocationID(locationIdFromSettings);
    } else if (!isLoading && detailedLocationSettings.length === 0) {
      setupdatedlocationID(null);
    }
  }, [detailedLocationSettings, isLoading]);
  if (!locationID && (isLoading || updatedlocationID === undefined)) {
    return null;
  }
  if (!locationID && updatedlocationID === null) {
    return <NotFound />;
  }
  const LocationIDparam = locationID || updatedlocationID;
  if (!stepNumber) {
    return <Navigate to={navigate.getPlaceOrderUrl(LocationIDparam, 1)} />;
  }

  return <PlaceOrder locationID={LocationIDparam} />;
}
function OrderDetailsRouter() {
  let { confirmationNumber } = useParams();
  confirmationNumber = parseInt(confirmationNumber);

  return (
    <React.Fragment>
      {!confirmationNumber ? <NotFound /> : <OrderDetails />}
    </React.Fragment>
  );
}